export default __webpack_public_path__ + "static/media/Outlook-Logo.347d3868.svg";